import { selectActiveOperator } from "@/redux/apis/operator/helpers";
import { useGetClientOperatorsQuery } from "@/redux/apis/operator/operatorApi";
import { AnnouncementBar } from "./AnnouncementBar";
import { ANNOUNCEMENT_MESSAGES } from "./announcementMessages";

/**
 * Client Portal banner for CLIENTS, EAs and Travel Managers (DEV-1486).
 *
 * The client-facing counterpart to ClientPortalAnnouncementBanner. Without it, flipping the phase to
 * `live` tells operators the release has landed while the people it is actually about — the clients
 * now sitting in this portal — are told nothing at all. Before the swap they get the same message on
 * the legacy pages, so this is what keeps them informed once the redirect has moved them here.
 *
 * ## Where the phase comes from
 *
 * Clients have no `activeOperator` — `useSetupClientAccount` resolves their provider only to pick
 * branding and never stores it — so this reads the operators list directly. The same response the
 * setup hook already fetches, so the cache is warm and this adds no request; RTK Query dedupes the
 * subscription.
 *
 * `selectActiveOperator` is the portal's own rule for which membership counts, reused rather than
 * reinvented so the banner cannot disagree with the branding about which provider the client is on.
 *
 * Every step is optional-chained: no operators, no announcement, or a phase of "" all mean render
 * nothing. An announcement must never be able to break the page it sits on.
 */
export const ClientPortalClientBanner = () => {
  const { data } = useGetClientOperatorsQuery();

  const announcement = data ? selectActiveOperator(data.data.operators)?.announcement : undefined;
  const phase = announcement?.clientPortalPhase;
  if (!phase) return null;

  const { lead, body } = ANNOUNCEMENT_MESSAGES.client[phase];

  return <AnnouncementBar lead={lead} body={body} url={announcement.clientPortalUrl} />;
};
